var map = {
	"./da.json": "df88",
	"./de.json": "bac1",
	"./en.json": "e312",
	"./es.json": "ef52",
	"./fr.json": "b16e",
	"./it.json": "669f",
	"./nl.json": "b94d",
	"./se.json": "be3d"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8825";
module.exports = webpackAsyncContext;